import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { CoreButton } from "../../core/ui/button/button";
import { CoreInput } from "../../core/ui/input/input";
import { authorizationStore as store } from "./authorization_store";
import { AccessDenied } from "./session_controls";

export const AuthorizationScreenPath = "/auth";
export const AuthorizationScreen = observer(() => {
  useEffect(() => { void store.restore(); }, []);
  if (!store.isInitialized) return <div role="status">Проверяем вход…</div>;
  if (store.user?.role === "admin") return <Navigate to="/task" replace />;
  if (store.user) return <AccessDenied />;
  return (
    <main className="admin-login">
      <h1>Вход в админку</h1>
      <form onSubmit={event => { event.preventDefault(); void store.onTapLogin(); }}>
        <CoreInput native label="Логин" autoComplete="username"
          value={store.authorizationModel.login} disabled={store.isLoading}
          onChange={store.changeLogin} />
        <CoreInput native label="Пароль" inputType="password" autoComplete="current-password"
          value={store.authorizationModel.password} disabled={store.isLoading}
          onChange={store.changePassword} />
        {store.errorMessage && <p role="alert">{store.errorMessage}</p>}
        <CoreButton type="submit" filled disabled={store.isLoading}>
          {store.isLoading ? "Входим…" : "Войти"}
        </CoreButton>
      </form>
    </main>
  );
});
